// src/components/ui/SparkleParticles.tsx
import React from 'react';

const SparkleParticles: React.FC = () => {
  const particles = Array.from({ length: 20 });

  return (
    <div className="absolute inset-0 overflow-visible pointer-events-none">
      {particles.map((_, i) => {
        const top = Math.random() * 100;
        const left = Math.random() * 100;
        const duration = 2 + Math.random() * 3;
        const delay = Math.random() * 2;

        return (
          <span
            key={i}
            className="absolute w-1 h-1 bg-primaryGray rounded-full animate-sparkle"
            style={{
              top: `${top}%`,
              left: `${left}%`,
              animationDuration: `${duration}s`,
              animationDelay: `${delay}s`,
            }}
          ></span>
        );
      })}
    </div>
  );
};

export default SparkleParticles;
